import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { TemplatesLink } from 'utils/link';
import { useError } from 'contexts/error';
import { BreadCrumbLink } from 'components/styles_components/link';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import TemplateQuery from 'queries/template/show';
import ShowItem from 'components/template/show_item';
import BreadcrumbContainer from 'components/layout/breadcrumb_container';
import LoaderContainer from 'components/layout/loader_container';
import TopMenu from 'components/layout/top_menu';

const Template = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const setError = useError();
  const {
    data = { template: { templateFields: [] }, space: { adminRole: true } },
    loading,
    error,
    refetch,
  } = useQuery(TemplateQuery, {
    variables: { id },
    onError: () => {
      setError('error.template.show');
      navigate(TemplatesLink());
    },
  });

  return (
    <>
      <TopMenu>
        <BreadcrumbContainer>
          <BreadCrumbLink to={TemplatesLink()}>
            <FormattedMessage id="breadcrumb.template.index" />
          </BreadCrumbLink>
          <BreadCrumbTypography>{data.template.name}</BreadCrumbTypography>
        </BreadcrumbContainer>
      </TopMenu>
      <LoaderContainer loading={loading} error={error}>
        <ShowItem template={data.template} space={data.space} refetch={refetch} />
      </LoaderContainer>
    </>
  );
};

export default Template;
